import React, { Component } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import { Button, Form, Spin, Icon, Upload, message, Modal, Alert } from 'antd';
import WxEditor from '@/components/WxEditor';
import FormCreate from '../../../../../components/FormCreate/index';
import Container from '../../../../../components/Container';
import { url as api } from '../../services/service-utils';
import { getAppCode, GetQueryString } from '../../utils/utils';
import styles from './index.less';

const { Item } = Form;
const { FormTitle, FormTextArea } = FormCreate;
const { confirm } = Modal;

let wwei_editor = null;
@Form.create()
@connect(({ moduleCreate }) => ({
  ...moduleCreate,
}))
class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: '',
      previewVisible: false,
      spinning: false,
      previewId: '',
    };
    this.id = GetQueryString('id');
  }

  componentDidMount() {
    wwei_editor = window.UE.getEditor('wwei_editor');
    if (this.id) {
      this.fetchTemplateById();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'moduleCreate/reset',
    });
  }

  fetchTemplateById = () => {
    const { dispatch, formData } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'moduleCreate/fetchTemplateById',
      params: { templateId: this.id },
    })
      .then(res => {
        this.setState({ spinning: false });
        dispatch({
          type: 'moduleCreate/saveState',
          payload: {
            formData: { ...formData, ...res },
            fileList: [
              {
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: res.templateCoverPicFileIdUrl,
              },
            ],
          },
        });
        wwei_editor = window.UE.getEditor('wwei_editor');
        wwei_editor.ready(function() {
          wwei_editor.setContent(res.templateContent);
        });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  handleCancel = () => {
    this.setState({
      previewImage: '',
      previewVisible: false,
    });
  };

  handleChange = info => {
    let { fileList } = info;
    fileList = fileList.slice(-1);
    fileList = fileList.map(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
      }
      return file;
    });
    fileList = fileList.filter(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
        return file.response.code === 0;
      }
      return true;
    });
    const { dispatch, formData } = this.props;
    dispatch({
      type: 'moduleCreate/saveState',
      payload: {
        fileList,
        formData: {
          ...formData,
          templateCoverPicFileId:
            fileList[0] &&
            fileList[0].response &&
            fileList[0].response.data &&
            fileList[0].response.data.fileId,
        },
      },
    });
  };

  handleOk = status => {
    const { form, formData } = this.props;
    const { validateFields } = form;
    validateFields(err => {
      if (!err && formData.templateCoverPicFileId) {
        this.saveArticle(status);
      } else {
        message.error('信息填写页必填项未填写完整');
      }
    });
  };

  saveArticle = status => {
    const { previewId } = this.state;
    const { form, formData } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    // eslint-disable-next-line camelcase
    wwei_editor = window.UE.getEditor('wwei_editor');
    const templateContent = wwei_editor.getContent();
    const params = {
      ...formData,
      ...values,
      templateCoverPicFileId: formData.templateCoverPicFileId,
      templateContent: templateContent || '',
      id: this.id || formData.id || previewId || 0,
    };
    this.fetchSaveOrUpdateTemplate(params, status);
  };

  fetchSaveOrUpdateTemplate = (params, type) => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'moduleCreate/fetchSaveOrUpdateTemplate',
      params: {
        ...params,
        appCode: getAppCode(),
      },
    })
      .then(res => {
        this.setState({ spinning: false });
        if (type === 'preview') {
          this.fetchPreviewTemplate(res);
          this.setState({ previewId: res });
        } else {
          message.success('保存成功');
          router.goBack();
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchPreviewTemplate = id => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'moduleCreate/fetchPreviewTemplate',
      params: { templateId: id, appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ spinning: false });
        message.success('模板预览已发送至您的手机，请打开微信查看');
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchDeleteById = () => {
    const that = this;
    confirm({
      title: '确认删除?',
      content: '',
      onOk() {
        const { dispatch } = that.props;
        that.setState({ spinning: true });
        dispatch({
          type: 'moduleCreate/fetchDeleteById',
          params: { templateId: that.id, appCode: getAppCode() },
        })
          .then(() => {
            that.setState({ spinning: false });
            message.success('删除成功');
            router.goBack();
          })
          .catch(() => {
            that.setState({ spinning: false });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  renderFooter = () => {
    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button type="default" onClick={() => this.handleOk('preview')}>
            预览
          </Button>
          {this.id && (
            <Button type="default" onClick={this.fetchDeleteById}>
              删除
            </Button>
          )}
          <Button type="primary" onClick={() => this.handleOk('save')}>
            发布
          </Button>
        </>
      ),
    };

    return footerParams;
  };

  render() {
    const that = this;
    const { previewImage, previewVisible, spinning } = this.state;
    const { form, dispatch, fileList, formData } = this.props;
    const { templateTitle, templateSummary, templateContent } = formData;
    const { getFieldsValue, getFieldDecorator } = form;

    const formItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
    };

    const customerFormItemLayout = {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
    };

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传封面</div>
      </div>
    );
    const props = {
      action: `${api.url}/web/v3/news/file/upload`,
      withCredentials: true,
      name: 'file',
      listType: 'picture-card',
      fileList,
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const type = ['image/jpeg', 'image/png', 'image/jpg'];
          const isJPG = type.indexOf(file.type) !== -1;
          if (!isJPG) {
            message.error('只能上传jpg/png/jpeg格式图片!');
          }
          const isLt4M = file.size / 1024 / 1024 < 5;
          if (!isLt4M) {
            message.error('图片不能大小超过5MB!');
          }
          if (!isJPG || !isLt4M) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false);
          }
          return resolve(true);
        });
      },
      onPreview(file) {
        that.setState({
          previewImage: file.url || file.thumbUrl,
          previewVisible: true,
        });
      },
      onRemove() {
        dispatch({
          type: 'moduleCreate/saveState',
          payload: { fileList: [] },
        });
      },
    };

    const titleProps = {
      form,
      value: templateTitle,
      label: '文章标题',
      keyName: 'templateTitle',
      maxLength: 100,
      suffix: `${(getFieldsValue().templateTitle && getFieldsValue().templateTitle.length) ||
        0}/100`,
    };

    const summaryProps = {
      form,
      value: templateSummary,
      label: '文章摘要',
      keyName: 'templateSummary',
      isRequired: false,
      maxLength: 200,
      rows: 4,
    };

    return (
      <Container breStates={!0} version={2} footerParams={this.renderFooter()}>
        <div className={styles['module-create']}>
          <Spin spinning={spinning}>
            <div className={styles.root}>
              <Alert
                message="内容发布后，需要关联可查看该模版内容的学校。被关联的学校可查看到该模版文章。"
                type="info"
                showIcon
              />
              <FormCreate customerFormItemLayout={customerFormItemLayout}>
                <FormTitle {...titleProps} />
                <Item label="文章内容" className="content">
                  {getFieldDecorator('templateContent', {
                    initialValue: templateContent,
                    rules: [{ required: true, message: '请填写文章内容' }],
                  })(<WxEditor showTemplate />)}
                </Item>
                <Form.Item label="封面" {...formItemLayout} className="necessary imgBox">
                  {getFieldDecorator(`templateCoverPicFileId`)(
                    <>
                      <Upload {...props} onChange={this.handleChange}>
                        {fileList.length >= 1 ? null : uploadButton}
                      </Upload>
                      <Modal
                        centered
                        width={950}
                        visible={previewVisible}
                        footer={null}
                        onCancel={this.handleCancel}
                      >
                        <div
                          style={{
                            backgroundImage: `url(${previewImage})`,
                            width: 900,
                            height: 383,
                            backgroundPosition: '50% 50%',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                          }}
                        />
                      </Modal>
                    </>
                  )}
                  <div className="upload-img-tips">说明：建议尺寸900*383，封面图最大可上传5M</div>
                </Form.Item>
                <FormTextArea {...summaryProps} />
              </FormCreate>
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Create;
